import { Link, NavLink } from "react-router-dom";
import { useState } from "react";
import "../styles/components/Header.css";

const nav = [
  { to: "/usluge", label: "Usluge" },
  { to: "/za-kompanije", label: "Za Kompanije" },
  { to: "/cenovnik", label: "Cenovnik" },
  { to: "/kontakt", label: "Kontakt" },
  // { to: "/blog", label: "Blog" },
];

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="site-header">
      <div className="wrapper">
        <Link to="/" className="logo">
          <img 
            src="/images/logo-bird.webp" 
            alt="Clarity - Psihološko savetovalište logo"
            width="50"
            height="50"
            loading="eager"
          />
          Clarity
        </Link>

        {/* Hamburger button */}
        <button
          className={`hamburger ${menuOpen ? "active" : ""}`}
          onClick={() => setMenuOpen((prev) => !prev)}
          aria-label="Toggle menu"
        >
          <span />
          <span />
          <span />
        </button>

        <nav className={`nav-links ${menuOpen ? "open" : ""}`}>
          {nav.map(({ to, label }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) =>
                `nav-link ${isActive ? "active" : ""}`
              }
              onClick={() => {
                setMenuOpen(false)
              }}
            >
              {label}
            </NavLink>
          ))}
        </nav>
      </div>
    </header>
  );
}
